import { Text } from '@chakra-ui/react';

// Flags whether content is MyOmnia platform content or authored by a creator.
const ContentOriginBadge = ({ isPlatformContent }: { isPlatformContent?: boolean }) => (
  <Text
    as="span"
    fontSize="12px"
    fontWeight={700}
    paddingX="10px"
    paddingY="2px"
    borderRadius="full"
    color={isPlatformContent ? 'primary.600' : 'text.mediumBlue'}
    bgColor={isPlatformContent ? 'primary.100' : 'background.cloudGray'}
  >
    {isPlatformContent ? 'MyOmnia' : 'Creator'}
  </Text>
);

export default ContentOriginBadge;
